export interface OdometerConfigModel {
  animation?: string;
  format?: string;
  theme?: string;
  value?: number;
  duration?: number;
  auto?: boolean;
}

export class OdometerConfig implements OdometerConfigModel {
  animation ? = 'slide';
  format = '(,ddd)';
  theme ? = 'default';
  value ? = 0;
  duration ? = 100;
  auto ? = true;
}
